import React, { useState, useEffect, useReducer, memo, useCallback } from "react";
import _, { constant, set } from "lodash";

// ============== Components =============
import {
  Table,
  Form,
  Pagination,
  InputGroup,
  ListGroup,
  Toast,
  Spinner,
  Row,
  Col,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Email, RemoveRedEye, TramOutlined } from "@material-ui/icons";
import Loader from "../../../components/Loader/Loader";
import {
  TextField,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Divider,
  Typography,
  Checkbox,
} from "@material-ui/core";

import Button from "react-bootstrap/Button";
import { Edit, RemoveCircle, Add, Delete, People } from "@material-ui/icons";

//
import CouponTable from "./components/table";
import CouponForm from "./components/form";

/*
 *   ============== Util ===================
 * */
import { DateTimeFormat } from "../../../util/DateTimeFormat";
import { DateFormat } from "../../../util/DateFormat";
import { CurrencyFormat } from "../../../util/currencyFormat";

// =============== Reducer ===============
import {
  ACTIONS,
  INITIAL_REQUEST_STATE,
  requestReducer,
} from "./reducer/requestReducer";
import { FORM_ACTIONS, formReducer, INITIAL_FORM_STATE } from "./reducer/form";

/*
 *   ================= API ================
 * */
import API from "../../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import {
  FORM_VALIDATE_ACTIONS,
  formValidateReducer,
  INITIAL_FORM_ERRORS,
} from "./reducer/formValidateReducer";
import moment from "moment";
import {
  ACTIONS_HISTORY,
  couponHistoryReducer,
  INITIAL_COUPON_HISTORY_STATE,
} from "./reducer/historyList";
import {StringToNumber, StringToNumberOrDouble} from "../../../util/stringToNumber";
import { CouponTypes } from "./helper";

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  table tr th {
    position: sticky;
    top: 0;
    border: 1px solid #dee2e6;
    background-color: #f9f9f9;
    z-index: 100;
  }

  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;
    margin-bottom: 20px;
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Coupon = (props) => {
  /*
   *   ===================== Request state ===================
   * */

  const [requestState, dispatch] = useReducer(
    requestReducer,
    INITIAL_REQUEST_STATE
  );
  const { isRequesting, requestError } = requestState;
  /*
   *   ===================== End request state ===================
   * */

  /*
   *   ===================== Toast ===================
   * */
  const [toastBgColor, setToastBgColor] = useState("bg-success");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Delete successful");

  const handleShowToast = (type) => {
    setShowToast(true);

    if (type === "SUCCESS") {
      setToastBgColor("bg-success");
      setToastMessage("Operation successful.");
    } else if (type === "ERROR") {
      setToastBgColor("bg-danger");
      setToastMessage("Operation error.");
    }
  };
  /*
   *   ===================== End Toast ===================
   * */

  /*
   *   ===================== Form Modal ===================
   * */
  const [formState, dispatchForm] = useReducer(formReducer, INITIAL_FORM_STATE);
  const [discountType, setDiscountType] = useState("FIXED_PRICE");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [formType, setFormType] = useState("Add");
  const handleEditCoupon = (coupon) => {
    let couponObj = _.cloneDeep(coupon);
    if(couponObj.supplier.length > 0) {
      couponObj.suppliers = JSON.parse(couponObj.supplier);
    }
    if(couponObj.category.length > 0) {
      couponObj.category = JSON.parse(couponObj.category);
    } 
    if(couponObj.product.length > 0) {
      couponObj.products = JSON.parse(couponObj.product);
    }
    if(couponObj.brand.length > 0) {
      couponObj.brand = JSON.parse(couponObj.brand);
    } 
    if(couponObj.sub_category.length > 0) {
      couponObj.sub_category = JSON.parse(couponObj.sub_category);
    }
    
    couponObj.validFrom = moment(
      new Date(couponObj.validFrom),
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    couponObj.validTo = moment(
      new Date(couponObj.validTo),
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    setDiscountType(couponObj.discountFixedPrice && StringToNumberOrDouble(couponObj.discountFixedPrice) > 0 ? "FIXED_PRICE": "PERCENTAGE")
    dispatchForm({ type: FORM_ACTIONS.UPDATE_FORM_DATA, payLoad: couponObj });

    setFormType("Update");
    setIsOpenModal(true);
    if ([CouponTypes.Generated, CouponTypes.Template, CouponTypes.Registration].includes(couponObj?.type) || [1, 3].includes(activeTab)) {
      setShowValidateDate(true);
    }
  };

  const [userModal, setUserModal] = useState(false);
  const [listCouponTemplateModal, setListCouponTemplateModal] = useState(false);
  const [listCouponTemplate, setListCouponTemplate] = useState([]);
  const [custSearch, setCustSearch] = useState("");
  const [removeUserModalConfirm, setRemoveUserModalConfirm] = useState(false);
  const [userPickerCode, setUserPickerCode] = useState(null);
  const [listCustomer, setListCustomer] = useState([]);
  const [couponSelected, setCouponSelected] = useState(null);
  const [pickerUser,setPickerUser] = useState({
    user_id: null,
    coupon_id: null,
  });
  const [selected, setSelected] = useState([]);
  // Handle row selection
  const handleClick = (event, cust_id) => {
    const selectedIndex = selected.indexOf(cust_id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, cust_id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  // Handle select all click
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = listCustomer.map((n) => n.cust_id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const pickerUserToCoupon = async (coupon=null) => {
    setUserModal(!userModal)
    SearchCustomerPickToCouponCode()
    setPickerUser({user_id:coupon?.user_id, coupon_id: coupon?._id});
    if(coupon){
      setCouponSelected(coupon)
      await API.getCustomerPickCouponCodeByCode({user_id:coupon?.user_id, coupon_id: coupon?._id})
      .then((res) => res.json())
      .then((res) => {
        if(res.success){
          setUserPickerCode(res.data)
        }else{
        }
      })
    }
    if(userModal === true){
      setUserPickerCode(null)
      setSelected([]);
      setCustSearch("")
    }
  };

  const handlePickerUser = async () => {
    if(activeTab === 1){
      await API.pickerUserToCoupon(pickerUser)
    .then((res) => res.json())
    .then((res) => {
      if(res.success){
        setUserModal(false);
        if(activeTab === 3){
          handleGetTemplateCoupon()
        }else{
          getCouponList({ search: searchText, types, status });
        }
        setPickerUser({
          user_id: null,
          coupon_id: null
        })
      }else{
        alert(res.message);
      }
    });
    }else if(activeTab === 3){
      let body = {
        ...couponSelected,
        custId:selected
      }
      await API.createCouponToCustomerFromTemplate(body)
      .then((res) => res.json())
      .then((res) => {
        if(res.success){
          setUserModal(false);
          handleGetTemplateCoupon()
          setPickerUser({
            user_id: null,
            coupon_id: null
          })
        }else{
          alert(res.message);
        }
      });
    }
    setCouponSelected(null)
    setSelected([]);
  }

  const handleGetTemplateCoupon = async (query=null) => {
    let body = {};
    if(query?.type){
      body.type = CouponTypes.Registration
    }
    if(query?.search){
      body.search = searchText
    }
    await API.getAllCouponTemplate(body).then((res) => res.json())
    .then((res) => {
      if(res.success){
        setListCouponTemplate(res.data.list)
        setCouponList(res.data.list)
        dispatch({ type: ACTIONS.SUCCESS });
        if(res.data.totalPage){
          setTotalPage(res.data.totalPage);
        }
        if(res.data.next !== null){
          setCurrentPage(res.data.next);
        }
      }
    });
  }
  const handleToggleModalTemplateCoupon = async () => {
    setListCouponTemplateModal(!listCouponTemplateModal)
    if(!listCouponTemplateModal){
      await handleGetTemplateCoupon()
    }else{
      getCouponList({ search: searchText, types, status });
      setCouponSelected(null)
    }
  };

  const handleCreateGenerateCoupon = async () => {
    await API.createCouponFromTemplate(couponSelected)
    .then((res) => res.json())
    .then((res) => {
      if(res.success){
        setCouponSelected(null)
        if(activeTab === 3){
          handleGetTemplateCoupon()
        }else{
          getCouponList({ search: searchText, types, status });
        }
        setListCouponTemplateModal(!listCouponTemplateModal)
      }else{
        alert(res.message);
        setCouponSelected(null)
        setListCouponTemplateModal(!listCouponTemplateModal)
      }
    })
  }

  const handleToggleModalRemoveUser = (data = null) => {
    setRemoveUserModalConfirm(!removeUserModalConfirm)
    setCustSearch("")
    setPickerUser({
      user_id: data?.user_id,
      coupon_id: data?.coupon_id,
    })
  }
  const handleRemovePickerUser = async () => {
    await API.RemoveCustomerPickCouponCodeByCode(pickerUser)
    .then((res) => res.json())
    .then((res) => {
      if(res.success){
        pickerUserToCoupon(pickerUser)
        getCouponList({ search: searchText, types, status });
        setPickerUser({
          user_id: null,
          coupon_id: null
        })
        setRemoveUserModalConfirm(!removeUserModalConfirm)
      }else{
        alert(res.message);
      }
    });
  }
  const SearchCustomerPickToCouponCode = async (text = custSearch || "a") => {
    await API.SearchCustomerPickToCouponCode({
      query:text
    })
    .then((res) => res.json())
    .then((res) => {
      if(res.success) {
        setListCustomer(res.data)
      }
    });
  };

  useEffect(() => {
    SearchCustomerPickToCouponCode(custSearch||"a")
  },[custSearch]);

  const handleAddCoupon = (type) => {
    setIsOpenModal(true);
    if(type === CouponTypes.Generated) {
      setShowValidateDate(true);
    }
  }
  // 
  const [showValidateDate,setShowValidateDate] = useState(false);

  // 

  const handleCloseModal = () => {
    setIsOpenModal(false);
    resetFormState();
    resetFormStateError();
    setFormType("Add");
    setDiscountType("FIXED_PRICE");
    setShowValidateDate(false)
  };

  const handleChangeDiscountType = (e) => {
    setDiscountType(e.target.value);
    const { name, value } = e.target;
    let tmpFormState = {
      ...formState
    }

    let payLoad = {};
    if (value === "FIXED_PRICE") {
      tmpFormState = {
        ...formState,
        discountPercentage: 0,
        discountFixedPrice: formState.discountPercentage
      };
      payLoad={
        value: formState.discountPercentage,
        formState: tmpFormState
      }
    } else {
      tmpFormState = {
        ...formState,
        discountPercentage: formState.discountFixedPrice,
        discountFixedPrice: 0
      };

      payLoad={
        value: formState.discountFixedPrice,
        formState: tmpFormState
      }
    }

    dispatchForm({
      type: FORM_ACTIONS.UPDATE_FORM_DATA,
      payLoad: tmpFormState,
    });
    dispatchFormValidate({
      type: "discountPercentage", payLoad
    });
  };
  /*
   *   ===================== End form Modal ===================
   * */

  /*
   *   ===================== Confirm modal ===================
   * */
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [couponIdToRemove, setCouponIdToRemove] = useState("");
  const handleOpenConfirmModal = (coupon) => {
    setCouponIdToRemove(coupon._id);
    setIsOpenConfirmModal(true);
  };
  const handleCloseConfirmModal = () => {
    setCouponIdToRemove("");
    setIsOpenConfirmModal(false);
  };
  const handleRemoveCoupon = () => {
    if (couponIdToRemove) {
      dispatch({ type: ACTIONS.CALLING_API });

      API.removeCoupon(couponIdToRemove)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            let tmpCouponList = couponList.filter((x) => x._id !== couponIdToRemove);
            setCouponList([...tmpCouponList]);
            setCouponIdToRemove("");
            dispatch({ type: ACTIONS.SUCCESS });
            handleShowToast("SUCCESS");
          } else {
            dispatch({ type: ACTIONS.ERROR, error: true });
            handleShowToast("ERROR");
          }
          handleCloseConfirmModal();
        });
    }
  };

  /*
   *   ===================== End confirm Modal ===================
   * */

  /*
   *   ===================== Table list ===================
   * */
  useEffect(() => {
    getCouponList({ search: searchText, types, status });
  }, []);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(0)
  const [newPage, setNewPage] = useState(0)
  const [totalPage, setTotalPage] = useState(0)
  const [limit, setLimit] = useState(10)

  const resetPagination = () => {
    setTotalPage(0)
    setNewPage(0)
    setCurrentPage(0)
    setLimit(10)
  }
  const handlePaginPrev = () => {
    if(activeTab === 3){
      setTypes([CouponTypes.Template, CouponTypes.Registration])
    }
    if(currentPage > 0){
      setNewPage(currentPage-1)
    }
  }
  const handlePaginNext = () => {
    if(activeTab === 3){
      setTypes([CouponTypes.Template, CouponTypes.Registration])
    }
    if(currentPage < totalPage -1){
      setNewPage(currentPage+1)
    }
    
  }

  // useEffect(() => {
  //   getCouponList({ search: searchText, types, status });
  // }, [newPage, types]);

  const [couponList, setCouponList] = useState([]);

  const getCouponList = ({ search, types, status },) => {
    dispatch({ type: ACTIONS.CALLING_API });

    let params = {
      next: newPage,
      limit: limit,
    };

    let queries = `types=${JSON.stringify(
      types
    )}&status=${status}&search=${search}`;

    API.getAllCoupons(params, queries)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setCouponList(res.data.list);
          if(res.data.totalPage){
            setTotalPage(res.data.totalPage);
          }
          if(res.data.next !== null){
            setCurrentPage(res.data.next);
          }
          dispatch({ type: ACTIONS.SUCCESS });
        } else {
          dispatch({ type: ACTIONS.ERROR, error: true });
          handleShowToast("ERROR");
        }
      });
  };
  /*
   *   ===================== End table list ===================
   * */

  /*
   *   ===================== Form ===================
   * */

  const [formErrorState, dispatchFormValidate] = useReducer(
    formValidateReducer,
    INITIAL_FORM_ERRORS
  );
  const { formErrors, isFormValid } = formErrorState;

  const resetFormState = () => {
    dispatchForm({ type: FORM_ACTIONS.RESET_FORM_STATE });
  };

  const resetFormStateError = () => {
    dispatchFormValidate({ type: FORM_VALIDATE_ACTIONS.RESET_FORM_ERROR });
  };

  const getValidateDate = (validateDays) => {
    // Current date in YYYY-MM-DD format
    const validFrom = moment().format("YYYY-MM-DD");
    // Future date after adding validateDays, also in YYYY-MM-DD format
    const validTo = moment().add(validateDays, 'days').format("YYYY-MM-DD");
  
    // Dispatch validFrom and validTo to the form state
    dispatchForm({ 
      type: FORM_ACTIONS.UPDATE_FORM_FIELD, 
      payLoad: {
        name: "validFrom",
        value: validFrom
      }
    });
    dispatchForm({ 
      type: FORM_ACTIONS.UPDATE_FORM_FIELD, 
      payLoad: {
        name: "validTo",
        value: validTo
      }
    });
  };
  const handleFormChange = (e) => {
    if (e.target.type == 'checkbox') {
      if(e.target.checked) {
        e.target.name == "isOneTimeUse" ? e.target.value = 0 : e.target.value = 1;
      } else {
        e.target.name == "isOneTimeUse" ? e.target.value = 1 : e.target.value = 0;
      }
    }

    if (e.target.name === "used_qty") {
      if ((/^([1-9]([0-9]+\s?){0,})*$/).test(e.target.value)) {
        e.target.value = e.target.value;
      } else return;
    }
    if (e.target.name === "valid_date") {
      getValidateDate(e.target.value);
    }
    if (e.target.name === "free_delivery") {
      // A free delivery coupon may have a 0 discount, so re-run the discount
      // validation with the new checkbox value (formState is still the old one).
      dispatchFormValidate({
        type: FORM_VALIDATE_ACTIONS.VALIDATE_FREE_DELIVERY,
        payLoad: {
          name: e.target.name,
          value: e.target.value,
          formState: { ...formState, free_delivery: e.target.value },
        },
      });
    }
    dispatchForm({ type: FORM_ACTIONS.UPDATE_FORM_FIELD, payLoad: e.target });
  };

  const handleFormSelect = (e) => {
    dispatchForm({ type: FORM_ACTIONS.UPDATE_FORM_FIELD, payLoad: e });
  };

  const handleFormBlur = (e) => {
    dispatchFormValidate({ type: e.target.name, payLoad: {name:e.target.name, value: e.target.value, formState} });
  };

  const handleSubmit = () => {
    if (!isFormValid && activeTab !== 3) {
      dispatchFormValidate({
        type: FORM_VALIDATE_ACTIONS.VALIDATE_ALL_FIELD,
        payLoad: formState,
      });
    }else if (!isFormValid && activeTab === 3) {
      dispatchFormValidate({
        type: FORM_VALIDATE_ACTIONS.VALIDATE_ALL_FIELD,
        payLoad: formState,
        formType: "template"
      });
    } else {
      dispatch({ type: ACTIONS.CALLING_API });

      let body = {
        ...formState,
        amount: StringToNumber(formState.amount),
        isOneTimeUse: StringToNumber(formState.isOneTimeUse),
        used_qty: StringToNumber(formState.used_qty),
        minimumBasketPrice: StringToNumber(formState.minimumBasketPrice),
        discountFixedPrice: discountType === "FIXED_PRICE"?StringToNumberOrDouble(formState.discountFixedPrice): 0,
        discountPercentage: discountType !== "FIXED_PRICE"?StringToNumberOrDouble(formState.discountPercentage): 0
      };
      let couponType;
      if(activeTab === 0 || activeTab === 2){
        couponType = CouponTypes.Manual
        body = {
          ...body,
          type: couponType,
        }
      }else if(activeTab === 3){
        couponType = formState.template_use_for

        body = {
          ...body,
          type: couponType,
        }
      }else {
        body = {
          ...body,
          type: formState.type,
        }
      }
      if (formType === "Update") {
        API.updateCoupon(body)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              const updatedIndex = couponList.findIndex(
                (x) => x._id === formState._id
              );
              if (updatedIndex > -1) {
                couponList[updatedIndex] = res.data;
                if(activeTab !== 3){
                  setCouponList([...couponList]);
                  getCouponList({ search: searchText, types, status });
                }else{
                  handleGetTemplateCoupon({type:CouponTypes.Registration})
                }
                dispatch({ type: ACTIONS.SUCCESS });
              }

              handleShowToast(ACTIONS.SUCCESS);
              handleCloseModal();
            } else {
              if(res.message !== "Coupon code already exists"){
                handleCloseModal();
              }else{
                dispatchFormValidate({
                  type: FORM_VALIDATE_ACTIONS.VALIDATE_CODE_EXIST
                });
              }
              handleShowToast(ACTIONS.ERROR);
              dispatch({ type: ACTIONS.ERROR });
            }
          });
      } else {
        API.createCoupon(body)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              handleShowToast(ACTIONS.SUCCESS);
              if(activeTab !== 3){
                dispatch({ type: ACTIONS.SUCCESS });
                getCouponList({ search: searchText, types, status });
              }else{
                handleGetTemplateCoupon({type:CouponTypes.Registration})
              }
              handleCloseModal();
            } else {
              if(res.message !== "Coupon code already exists"){
                handleCloseModal();

                handleShowToast(ACTIONS.ERROR);
                dispatch({ type: ACTIONS.ERROR });

                handleCloseModal();
              }else{
                dispatchFormValidate({
                  type: FORM_VALIDATE_ACTIONS.VALIDATE_CODE_EXIST
                });

                handleShowToast(ACTIONS.ERROR);
                dispatch({ type: ACTIONS.ERROR });
              }
            }
          });
      }
    }
  };

  /*
   *   ===================== End form ===================
   * */

  /*
   *   ===================== Form Modal ===================
   * */
  const [searchText, setSearchText] = useState("");

  const handleSearch = () => {
    resetPagination()
    if(activeTab === 3){
      handleGetTemplateCoupon({ search: searchText, type:CouponTypes.Registration });
    }else{
      getCouponList({ search: searchText, types, status });
    }
  };

  /*
   *   ===================== End form Modal ===================
   * */

  /*
   *   ===================== Start Tabs ===================
   * */
  const [status, setStatus] = useState("active");
  const [types, setTypes] = useState(["manual"]);
  const [activeTab, setActiveTab] = useState(0);

  const handleTypeChange = (key) => {
    if (Number(key) === 0) {
      setSearchText("");
      setTypes(["manual"]);
      setStatus("active");
      resetPagination()
      setCouponList([]);
      // getCouponList({ search: "", types: ["manual"], status: "active" });
    } else if (Number(key) === 1) {
      setSearchText("");
      setTypes(["generated"]);
      setStatus("active");
      resetPagination()
      setCouponList([]);
      // getCouponList({ search: "", types: ["generated"], status: "active" });
    } else if (Number(key) === 2) {
      setSearchText("");
      setTypes(Object.values(CouponTypes));
      setStatus("inactive");
      resetPagination()
      setCouponList([]);
      // getCouponList({
      //   search: "",
      //   types: ["generated", "manual"],
      //   status: "inactive",
      // });
    }else if (Number(key) === 3) {
      setSearchText("");
      handleGetTemplateCoupon({type:CouponTypes.Registration})
      setStatus("active");
      resetPagination()
      setCouponList([]);
    }

    setActiveTab(Number(key));
  };

  /*
   *   ===================== End Tabs ===================
   * */

  /*
   *   ===================== Start coupon Modal ===================
   * */
  const [isShowHistoryModal, setIsShowHistoryModal] = useState(false);
  const [couponToShowHistory, setCouponToShowHistory] = useState({});

  const handleShowHistory = (coupon) => {
    setIsShowHistoryModal(true);
    setCouponToShowHistory(coupon);
    getHistoryList(coupon._id);
  };

  const handleCloseHistoryModal = () => {
    setIsShowHistoryModal(false);
    resetHistoryList();
    setCouponToShowHistory({});
  };

  /*
   *   ===================== End coupon Modal ===================
   * */

  /*
   *   ===================== Start coupon state ===================
   * */
  const [
    { couponHistoryList, isLoadingCouponHistoryList, loadCouponHistoryError },
    dispatchCouponHistory,
  ] = useReducer(couponHistoryReducer, INITIAL_COUPON_HISTORY_STATE);

  const getHistoryList = (couponId) => {
    dispatchCouponHistory({
      type: ACTIONS_HISTORY.LOADING_HISTORY_LIST,
      payLoad: true,
    });

    API.getCouponUsage(couponId)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          dispatchCouponHistory({
            type: ACTIONS_HISTORY.LOAD_SUCCESS,
            payLoad: res.data,
          });
        } else {
          dispatchCouponHistory({
            type: ACTIONS_HISTORY.LOAD_FAILURE,
            payload: true,
          });
        }
      });
  };

  const resetHistoryList = () => {
    dispatchCouponHistory({
      type: ACTIONS_HISTORY.RESET_HISTORY_LIST,
      payLoad: [],
    });
  };

  /*
   *   ===================== End coupon state ===================
   * */

  useEffect(() => {
    getCouponList({ search: searchText, types, status });
  }, [newPage, types]);


  //Pagination Component
  const PaginationBasic = () => (
      <div className="d-flex justify-content-center">
        <Pagination>
          <Pagination.Item disabled={Number(currentPage) === 0} key={0} onClick={handlePaginPrev}>
            Prev
          </Pagination.Item>
          <Form.Group key={1} controlId="formGridPagination">
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>{`${currentPage + 1} / ${totalPage}`}</InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup>
          </Form.Group>
          <Pagination.Item disabled={(Number(currentPage)+1) >= Number(totalPage)} key={2} onClick={handlePaginNext}>
            Next
          </Pagination.Item>         
        </Pagination>
      </div>
  );

  return (
    <HelpPageWrapper>
      <Tabs
        activeKey={activeTab}
        transition={false}
        id="noanim-tab-example"
        className="tabProfile"
        onSelect={handleTypeChange}
      >
        {/*
                ================ Manual Coupon Tab =====================
            */}
        <Tab eventKey={0} title="Manual Coupon">
          {activeTab === 0 && (
            <>
              {/*
                ================ Start Table Filter =====================
            */}
              <Row className="mb-4">
                <Col sm={9}>
                  <Button
                    disabled={isRequesting}
                    variant="success"
                    onClick={() => handleAddCoupon("manual")}
                  >
                    <Add></Add> Add New
                  </Button>
                </Col>
                <Col sm={3} className="text-right">
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      id="searchText"
                      name="searchText"
                      value={searchText}
                      disabled={isRequesting}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search code or name"
                    />
                    <InputGroup.Append>
                      <Button
                        disabled={isRequesting}
                        variant="outline-secondary"
                        onClick={handleSearch}
                      >
                        {isRequesting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                        <span className="pl-2 pr-2">Search</span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Col>
              </Row>
              {/*
                ================ End Table Filter =====================
            */}

              {/*
                ================ Table =====================
            */}
              <Row>
                <Col sm={12}>
                  <div
                    className="table-responsive"
                    // style={{ height: "calc(100vh - 250px)" }}
                  >
                    <CouponTable
                      {...{ isRequesting, couponList, activeTab }}
                      onEdit={(coupon) => handleEditCoupon(coupon)}
                      onDelete={(coupon) => handleOpenConfirmModal(coupon)}
                      onShowHistory={(coupon) => handleShowHistory(coupon)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <PaginationBasic />
                </Col>
              </Row>
              {/*
                ================ End Table =====================
            */}
            </>
          )}
        </Tab>

        {/*
                ================ Generated Coupon Tab =====================
            */}
        <Tab eventKey={1} title="Generated Coupon">
          {activeTab === 1 && (
            <>
              {/*
                ================ Start Table Filter =====================
            */}
              <Row className="mb-4">
                <Col sm={9}>
                  <Button
                    disabled={isRequesting}
                    variant="success"
                    onClick={() => handleToggleModalTemplateCoupon()}
                  >
                    <Add></Add> Add New
                  </Button>
                </Col>
                <Col sm={3} className="text-right">
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      id="searchText"
                      name="searchText"
                      value={searchText}
                      disabled={isRequesting}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search code or name"
                    />
                    <InputGroup.Append>
                      <Button
                        disabled={isRequesting}
                        variant="outline-secondary"
                        onClick={handleSearch}
                      >
                        {isRequesting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                        <span className="pl-2 pr-2">Search</span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Col>
              </Row>
              {/*
                ================ End Table Filter =====================
            */}

              {/*
                ================ Table =====================
            */}
              <Row>
                <Col sm={12}>
                  <div
                    className="table-responsive"
                    // style={{ height: "calc(100vh - 250px)" }}
                  >
                    <CouponTable
                      {...{ isRequesting, couponList, activeTab }}
                      onEdit={(coupon) => handleEditCoupon(coupon)}
                      onDelete={(coupon) => handleOpenConfirmModal(coupon)}
                      onShowHistory={(coupon) => handleShowHistory(coupon)}
                      onPickerUser={(coupon) => pickerUserToCoupon(coupon)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <PaginationBasic />
                </Col>
              </Row>
              {/*
                ================ End Table =====================
            */}
            </>
          )}
        </Tab>

        <Tab eventKey={3} title="Template Coupon">
          {activeTab === 3 && (
            <>
              {/*
                ================ Start Table Filter =====================
            */}
              <Row className="mb-4">
                <Col sm={9}>
                  <Button
                    disabled={isRequesting}
                    variant="success"
                    onClick={() => handleAddCoupon("generated")}
                  >
                    <Add></Add> Add New
                  </Button>
                </Col>
                <Col sm={3} className="text-right">
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      id="searchText"
                      name="searchText"
                      value={searchText}
                      disabled={isRequesting}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search code or name"
                    />
                    <InputGroup.Append>
                      <Button
                        disabled={isRequesting}
                        variant="outline-secondary"
                        onClick={handleSearch}
                      >
                        {isRequesting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                        <span className="pl-2 pr-2">Search</span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Col>
              </Row>
              {/*
                ================ End Table Filter =====================
            */}

              {/*
                ================ Table =====================
            */}
              <Row>
                <Col sm={12}>
                  <div
                    className="table-responsive"
                    // style={{ height: "calc(100vh - 250px)" }}
                  >
                    <CouponTable
                      {...{ isRequesting, couponList, activeTab }}
                      onEdit={(coupon) => handleEditCoupon(coupon)}
                      onDelete={(coupon) => handleOpenConfirmModal(coupon)}
                      onShowHistory={(coupon) => handleShowHistory(coupon)}
                      onPickerUser={(coupon) => pickerUserToCoupon(coupon)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <PaginationBasic />
                </Col>
              </Row>
              {/*
                ================ End Table =====================
            */}
            </>
          )}
        </Tab>

        {/*
                ================ Generated Coupon Tab =====================
            */}
        <Tab eventKey={2} title="Inactive Coupon">
          {activeTab === 2 && (
            <>
              {/*
                ================ Start Table Filter =====================
            */}
              <Row className="mb-4">
                <Col sm={9}></Col>
                <Col sm={3} className="text-right">
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      id="searchText"
                      name="searchText"
                      value={searchText}
                      disabled={isRequesting}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search code or name"
                    />
                    <InputGroup.Append>
                      <Button
                        disabled={isRequesting}
                        variant="outline-secondary"
                        onClick={handleSearch}
                      >
                        {isRequesting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}

                        <span className="pl-2 pr-2">Search</span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Col>
              </Row>
              {/*
                ================ End Table Filter =====================
            */}

              {/*
                ================ Table =====================
            */}
              <Row>
                <Col sm={12}>
                  <div
                    className="table-responsive"
                    // style={{ height: "calc(100vh - 250px)" }}
                  >
                    <CouponTable
                      {...{ isRequesting, couponList, activeTab }}
                      onEdit={(coupon) => handleEditCoupon(coupon)}
                      onDelete={(coupon) => handleOpenConfirmModal(coupon)}
                      onShowHistory={(coupon) => handleShowHistory(coupon)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <PaginationBasic />
                </Col>
              </Row>
              {/*
                ================ End Table =====================
            */}
            </>
          )}
        </Tab>
      </Tabs>

      {/*
                ================ Form modal =====================
            */}
      <Modal
        show={isOpenModal}
        animation={false}
        onHide={handleCloseModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        {/* <Form autoComplete="false"> */}
        <Modal.Header closeButton>
          <Modal.Title>{formType} Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody">
          <CouponForm
            {...{
              formState,
              formErrors,
              isRequesting,
              discountType,
            }}
            onBlur={handleFormBlur}
            onChange={handleFormChange}
            onChangeDis={handleChangeDiscountType}
            onSelect={handleFormSelect}
            showValidateDate={showValidateDate}
            activeTab={activeTab}
            dispatchForm={dispatchForm}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={isRequesting} variant="info" onClick={handleSubmit}>
            {isRequesting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}

            <span className="pl-2 pr-2">Save</span>
          </Button>
          <Button
            disabled={isRequesting}
            variant="secondary"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Modal.Footer>
        {/* </Form> */}
      </Modal>
      {/*
                ================ End form modal =====================
            */}

      {/*
                ================ Confirm remove modal =====================
            */}
      <Modal
        show={isOpenConfirmModal}
        animation={false}
        onHide={handleCloseConfirmModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="xs"
        centered
      >
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title className="text-white">Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Form.Label>Do you want to remove this coupon?</Form.Label>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="danger"
            disabled={isRequesting}
            onClick={handleRemoveCoupon}
          >
            {isRequesting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}

            <span className="pl-2 pr-2">Ok</span>
          </Button>

          <Button
            variant="secondary"
            disabled={isRequesting}
            onClick={handleCloseConfirmModal}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/*
                ================ End confirmat remove modal =======================
            */}

      {/*
                ================ History modal =====================
            */}
      <Modal
        show={isShowHistoryModal}
        animation={false}
        onHide={handleCloseHistoryModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-black">
            Historic of code: {couponToShowHistory?.code}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>FirstName</th>
                <th>LastName</th>
                <th>Phone</th>
                <th>Email</th>
              </tr>
            </thead>

            <tbody>
              {couponHistoryList.length ? (
                couponHistoryList.map((history, index) => {
                  return (
                    <tr key={index}>
                      <td>{history.firstName || "-"}</td>
                      <td>{history.lastName || "-"}</td>
                      <td>{history.phone || "-"}</td>
                      <td>{history.email || "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            disabled={isRequesting}
            onClick={handleCloseHistoryModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/*
                ================ End history modal =======================
            */}
     {/* list template coupon */}
      <Modal
        show={listCouponTemplateModal}
        animation={true}
        onHide={handleToggleModalTemplateCoupon}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <Modal.Header closeButton className="bg-primary">
          <Modal.Title className="text-black">
            Coupon Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Validity</th>
                <th>Discount</th>
              </tr>
            </thead>

            <tbody>
              {listCouponTemplate.length ? (
                listCouponTemplate.map((co, index) => {
                  return (
                    <tr onClick={() => setCouponSelected(co)} key={index} style={{cursor:'pointer',backgroundColor: co._id === couponSelected?._id && "gray"}}>
                      <td>{co?.code || "-"}</td>
                      <td>{co?.name || "-"}</td>
                      <td>{`${co?.valid_date} (${co?.validity_type})` || "-"}</td>
                      <td>{co?.discountPercentage
                                  ? co?.discountPercentage + " % "
                                  : co?.discountFixedPrice
                                  ? CurrencyFormat(co?.discountFixedPrice)
                                  : "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            disabled={isRequesting}
            onClick={handleToggleModalTemplateCoupon}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={!couponSelected}
            onClick={() => handleCreateGenerateCoupon()}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>
      {/*
                ================ Toast =================
            */}

      {/*  */}
      <Modal
        show={userModal}
        animation={true}
        onHide={pickerUserToCoupon}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-success">Picker User</Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Row xs={12}>
            <Col xs={12} className="d-flex align-items-center">
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                className="my-2"
                placeholder="Search Customer"
                value={custSearch}
                onChange={(e) => setCustSearch(e.target.value)}
              />
              <Button
                style={{ marginLeft: "5px" }}
                variant="outline-info"
                onClick={() => SearchCustomerPickToCouponCode()}
              >
                Search
              </Button>
            </Col>
          </Row>
          {userPickerCode && (
            <>
              <hr />
              <Typography
                color="error"
                variant="h6"
                className="font-weight-bold"
              >
                This Coupon Alreday Pick To Customer :{" "}
              </Typography>
              {/* <Typography variant="h6" className="font-weight-bold">Name : {userPickerCode?.customer_detail?.name}</Typography>
                  <Typography variant="h6" className="font-weight-bold">Email : {userPickerCode?.customer_detail?.email || "undefined"}</Typography>
                  <Typography variant="h6" className="font-weight-bold">Phone : {userPickerCode?.customer_detail?.phone || "undefined"}</Typography> */}
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Customer Id</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{userPickerCode?.user_id}</td>
                    <td>
                      {userPickerCode?.customer_detail?.name || "undefined"}
                    </td>
                    <td>
                      {userPickerCode?.customer_detail?.email || "undefined"}
                    </td>
                    <td>
                      {userPickerCode?.customer_detail?.phone || "undefined"}
                    </td>
                    <td>
                      <Tooltip title="Click to Delete" placement="top" arrow>
                        <Button
                          variant="danger"
                          onClick={() =>
                            handleToggleModalRemoveUser(userPickerCode)
                          }
                        >
                          <Delete className="text-white"></Delete>
                        </Button>
                      </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <hr />
            </>
          )}
          <Table striped bordered hover>
            <thead>
              <tr>
                {activeTab === 3 && <th>
                  <Checkbox
                    checked={
                      listCustomer?.length > 0 &&
                      selected?.length === listCustomer?.length
                    }
                    color="primary"
                    onChange={handleSelectAllClick}
                    inputProps={{ "aria-label": "select all items" }}
                  />
                </th>}
                <th>Customer Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {listCustomer.length > 0 &&
                listCustomer.map((e, idx) => {
                  const isItemSelected =
                      selected.indexOf(e.cust_id) !== -1;
                  return(
                  <tr
                    onClick={() =>
                      setPickerUser({
                        coupon_id: pickerUser.coupon_id,
                        user_id: e.cust_id,
                      })
                    }
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        (pickerUser.user_id === e.cust_id) && activeTab !== 3
                          ? "#ed7b64"
                          : "transparent",
                    }}
                    key={idx}
                  >
                    {activeTab === 3 && <td>
                      <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleClick(event, e.cust_id)}
                        color="primary"
                        inputProps={{ "aria-labelledby": e.cust_id }}
                      />
                    </td>}
                    <td>{e.cust_id}</td>
                    <td>{e.name}</td>
                    <td>{e.email}</td>
                    <td>{e.phone}</td>
                  </tr>
                )})}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            disabled={isRequesting}
            onClick={pickerUserToCoupon}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            disabled={isRequesting}
            onClick={() => handlePickerUser()}
          >
            {isRequesting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}

            <span className="pl-2 pr-2">Pick User</span>
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={removeUserModalConfirm}
        onHide={handleToggleModalRemoveUser}
        aria-labelledby="contained-modal-title-vcenter"
        size="xs"
        centered
      >
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title className="text-white">Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Form.Label>
            Do you want to remove this Customer From this coupon code?
          </Form.Label>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="danger"
            disabled={isRequesting}
            onClick={handleRemovePickerUser}
          >
            {isRequesting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}

            <span className="pl-2 pr-2">Ok</span>
          </Button>

          <Button
            variant="secondary"
            disabled={isRequesting}
            onClick={handleToggleModalRemoveUser}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Toast
        className={toastBgColor}
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        style={{
          position: "fixed",
          top: 70,
          right: 35,
          zIndex: 1041,
          width: "300px",
        }}
      >
        <Toast.Header>
          <strong className="mr-auto m-3">{toastMessage}</strong>
        </Toast.Header>
      </Toast>
      {/*
                ================ End Toast =================
            */}
    </HelpPageWrapper>
  );
};

export default memo(Coupon);
